import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Your Firebase config - replace with your actual config
const firebaseConfig = {
  apiKey: "AIzaSyDAJKI0IfWGuayzdpadTziNn7BXLxNcnH4",
  authDomain: "littlo-ecc3f.firebaseapp.com",
  projectId: "littlo-ecc3f",
  storageBucket: "littlo-ecc3f.firebasestorage.app",
  messagingSenderId: "604766184277",
  appId: "1:604766184277:web:4fb353de96ca5454d205dc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Connect to emulators in development
if (import.meta.env.DEV) {
  // Uncomment these lines if you want to use Firebase emulators in development
  // connectAuthEmulator(auth, 'http://localhost:9099');
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectStorageEmulator(storage, 'localhost', 9199);
}

export default app;
